import { ArrowLeftOutlined, CaretDownOutlined, CopyOutlined, DeleteOutlined, DownOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Input, Mentions, message, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../../Layout";
import useToast from "../../hook/useToast";
import { buildOptionsV2, convertStringToHTML, fommatSelectOption } from "../../until";
import useDebounce from "../../hook/useDebounce";
import { getSlListCustomerFieldsV2, getSLParameters, getSLTemplate, ISelectOption, ISelectOptiongTemplateZaloFromConek, ISelectOptionMentions, ISLCustomerFields } from "../../api/selectOptions/selectOptionsApi";
import { gListTypeZNS, ITypeZNS } from "../../api/selectOption/selectOptionsApi";
import { URL_TEMPLATE_IMG } from "../../env";

import './NotificationDetail.scss'
import { carDefault } from "../../components/ExportImgFigma";
import useLoading from "../../hook/useLoading";
import { formatSelectOptionMentions } from "./NotificationSMSCreate";
import { useForm } from "antd/es/form/Form";
import { addNotificationTemplate, getInfoTemplate, getListBrandNames, getTemplateZaloFromConek, IBrandConfigs, ITemplateZaloFromConek } from "../../api/notificationTemplate/notificationTemplateApi";
import { CHANNELTYPE } from "../../services/data";
import useThrottle from "../../hook/useThrottle";


const NotificationZNSCreate: React.FC = () => {

  useEffect(() => {
    gSListTypeZNS()
    gSlListCustomerFieldsV2()
    gSTemplateZaloFromConek()
    gSLParameters()
    gListBrandNames()
  }, []);

  const navigate = useNavigate()
  const pushToast = useToast();
  const pushLoading = useLoading()
  const [form] = useForm()
  const location = useLocation();
  const { type: typeState } = location?.state ?? {}

  const brandNameIds = Form.useWatch("brandNameIds", form) || []
  const typeZNSId = Form.useWatch("typeZNSId", form)
  const templateId = Form.useWatch("templateId", form)
  const content = Form.useWatch("content", form) ?? ""
  const selectedIds = useMemo(
    () => brandNameIds.map((i: any) => i?.brandName).filter(Boolean),
    [brandNameIds]
  );
  const [sLTemplate, setSLTemplate] = useState<ISLCustomerFields[]>([])
  const [searchText, setSearchText] = useState('');


  const [openMap, setOpenMap] = useState<boolean>();
  const [expandMap, setExpandMap] = useState<string[]>([]);
  const [searchTemplate, setSearchTemplate] = useState<string>('')
  const [selectValue, setSelectValue] = useState<number | undefined>(undefined)


  const [sLTypeZNS, setSLTypeZNS] = useState<ITypeZNS[]>([])
  const [sLTemplateZaloFromConek, setSLTemplateZaloFromConek] = useState<ISelectOptiongTemplateZaloFromConek[]>([])
  const [sLParameters, setSLParameters] = useState<ISelectOptionMentions[]>([])

  const [listBrandConfigs, setListBrandConfigs] = useState<IBrandConfigs[]>([])

  const [openCollapse, setOpenCollapse] = useState<boolean>(true)


  const convertOption = (
    data: ITemplateZaloFromConek[]
  ): ISelectOptiongTemplateZaloFromConek[] => {
    return data.map((item) => ({
      value: item.template_id,
      label: item.template_id,
      content: item.content
    }));
  };

  //#region  SL OP
  const gSListTypeZNS = async () => {
    const result = await gListTypeZNS()
    if (result?.status) {
      setSLTypeZNS(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }


  const gSTemplateZaloFromConek = async () => {
    const result = await getTemplateZaloFromConek()
    if (result?.status) {
      setSLTemplateZaloFromConek(convertOption(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gSlListCustomerFieldsV2 = useDebounce(async () => {
    pushLoading(true)
    const result = await getSlListCustomerFieldsV2(undefined, undefined, searchTemplate
    )
    if (result?.status) {
      setSLTemplate(result.data)
    }
    pushLoading(false)
  }, 1000)

  // hàm xử lý select trường V2
  const options = useMemo(() => buildOptionsV2(sLTemplate), [sLTemplate]);

  const selectableOptions = options.filter(
    (item) => !item.isGroup
  );
  // end





  const toggleGroup = (groupKey: string) => {
    setExpandMap((prev) =>
      prev.includes(groupKey)
        ? prev.filter((k) => k !== groupKey)
        : [...prev, groupKey]
    );
  };



  const gSLParameters = async () => {
    pushLoading(true)
    const result = await getSLParameters()
    if (result?.status) {
      setSLParameters(formatSelectOptionMentions(result.data))
    }
    pushLoading(false)
  }
  //#endregion

  const gListBrandNames = async () => {
    pushLoading(true)
    const result = await getListBrandNames(CHANNELTYPE.ZNS)
    if (result?.status) {
      setListBrandConfigs(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  // const gInfoTemplate = useDebounce(async () => {
  //   if (!templateId) {
  //     return
  //   }

  //   pushLoading(true)
  //   const result = await getInfoTemplate(templateId)
  //   if (result?.status) {
  //     form.setFieldValue("content", result.data.content)
  //   } else {
  //     pushToast(result?.message, "warning")
  //   }
  //   pushLoading(false)
  // }, 1000)

  const getOptions = (currentId?: number) => {
    return listBrandConfigs
      ?.filter(b => !selectedIds.includes(b.id) || b.id === currentId)
      ?.map(b => ({
        label: b.brandName,
        value: b.id
      }))
  }

  const handleSelectBrand = (value: number, index: number) => {
    const brand = listBrandConfigs.find(b => b.id === value)

    if (!brand) return

    const current = form.getFieldValue("brandNameIds") || []

    current[index] = {
      ...current[index],
      brandName: value,
      categoryCarIds: brand.categories
    }

    form.setFieldsValue({
      brandNameIds: current
    })
  }


  const onFinish = useThrottle(async (values: any) => {
    const { title, brandNameIds, typeZNSId, content, templateId } = values ?? {}

    // console.log(values)
    // return
    const brandNameIdsTmp = brandNameIds?.map((item: any) => item.brandName)
    // const templateIdTmp = brandNameIds.templateId
    pushLoading(true)
    const result = await addNotificationTemplate(
      title, content, CHANNELTYPE.ZNS, brandNameIdsTmp,
      undefined, typeZNSId, undefined, templateId
    )
    if (result.status) {
      pushToast(result.message, 'success', 2000)
      navigate('/marketing/notification-templates-management', {
        state: {
          type: typeState ?? CHANNELTYPE.ZNS
        }
      })
    } else {
      pushToast(result.message, 'error', 2000)

    }
    pushLoading(false)

  }, 1000)

  // useEffect(() => {
  //   gInfoTemplate()
  // }, [templateId])


  useEffect(() => {
    gSlListCustomerFieldsV2()
  }, [searchTemplate])

  return (
    <Layout>
      <div className="app-breadcrumb-block">
        <Breadcrumb
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: <Link to="/marketing/notification-templates-management">Marketing</Link>, },
            { title: <Link to="/marketing/notification-templates-management">Quản lý mẫu thông báo</Link>, },
            { title: 'Tạo nội dung mẫu ZNS', },
          ]}
        />
        <div className="d-flex align-baseline gap-3">
          <div className="app-breadcrumb-title">
            <div
              className="cursor-pointer"
              onClick={() => navigate(`/marketing/notification-templates-management`, { state: { type: typeState ?? CHANNELTYPE.ZNS } })}
            >
              <ArrowLeftOutlined />
            </div>
            <div className="title">Tạo mẫu mới </div>
          </div>
          <p className="text-sm font-regular text-98A2B3">
            Tạo nội dung mẫu ZNS
          </p>
        </div>

      </div>
      <div className="custom-page-css flex gap-6">
        <div className="custom-page-css flex flex-col flex-3 overflow-hidden gap-3">
          <Form
            className="custom-page-css flex flex-col gap-3"
            form={form}
            initialValues={{
              remember: true,
              brandNameIds: [
                {
                  brandName: undefined,
                }
              ]
            }}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <div className="custom-page-css flex items-center gap-6 justify-between">
              <Form.Item
                className='custom-page-css w-full'
                name="title"
                rules={[{ required: true, message: 'Tên mẫu không được để trống!' }]}
              >
                <Input
                  placeholder="Nhập tên mẫu, ví dụ: Mẫu chào sản phẩm mới"
                  className="custom-input-css custom-page-css"
                />
              </Form.Item>

              <Form.Item className='ctrl-w-btn'>
                <Button className="btn btn-primary" type="primary" htmlType="submit">
                  <div className="icon-svg">
                    <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_10159_3402)">
                        <path d="M12.9581 3.98491L10.4174 1.44429C10.3002 1.3271 10.1565 1.24116 10.0002 1.19429V1.1521H1.25024C0.973682 1.1521 0.750244 1.37554 0.750244 1.6521V13.1521C0.750244 13.4287 0.973682 13.6521 1.25024 13.6521H12.7502C13.0268 13.6521 13.2502 13.4287 13.2502 13.1521V4.69116C13.2502 4.42554 13.1456 4.17241 12.9581 3.98491ZM5.00024 2.2771H9.00025V3.9021H5.00024V2.2771ZM12.1252 12.5271H1.87524V2.2771H4.00024V4.4021C4.00024 4.67866 4.22368 4.9021 4.50024 4.9021H9.50025C9.77681 4.9021 10.0002 4.67866 10.0002 4.4021V2.61772L12.1252 4.74272V12.5271ZM7.00025 6.30835C5.75806 6.30835 4.75024 7.31616 4.75024 8.55835C4.75024 9.80054 5.75806 10.8084 7.00025 10.8084C8.24243 10.8084 9.25025 9.80054 9.25025 8.55835C9.25025 7.31616 8.24243 6.30835 7.00025 6.30835ZM7.00025 9.80835C6.30962 9.80835 5.75024 9.24898 5.75024 8.55835C5.75024 7.86773 6.30962 7.30835 7.00025 7.30835C7.69087 7.30835 8.25025 7.86773 8.25025 8.55835C8.25025 9.24898 7.69087 9.80835 7.00025 9.80835Z" fill="white" />
                      </g>
                      <defs>
                        <clipPath id="clip0_10159_3402">
                          <rect width="1em" height="1em" fill="white" transform="translate(0 0.400024)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className="text">Lưu mẫu</div>
                </Button>
              </Form.Item>
            </div>
            {/* <Form.Item
              className='custom-page-css w-full'
              name="templateId"
              rules={[{ required: true, message: 'ID mẫu không được để trống!' }]}
            >
              <Select
                placeholder="Nhập ID mẫu đã được duyệt bởi Zalo ZNS"
                className='custom-page-css border rounded overflow-hidden'
                options={sLTemplateZaloFromConek}
                // onChange={(data)=> console.log(data)}
                onSelect={(value, option) => {
                  // setContentTemplateZaloFromConek(option.content)
                  form.setFieldValue(
                    'content',
                    option.content ?? ''
                  );
                }}
              />
            </Form.Item> */}
            <div className="custom-page-css grid grid-cols-1fr_1fr gap-4 items-end">
              {/* <div className="custom-page-css flex items-center gap-3 text-base text-344054 font-medium cursor-pointer"
                onClick={() => setOpenCollapse(!openCollapse)}
              >
                Thiết lập brandname để gửi tin
                <DownOutlined style={{ rotate: openCollapse ? '180deg' : '0deg' }} />
              </div> */}
              <Form.List
                name="brandNameIds"
              >
                {(fields, { add, remove }) => (
                  <div className={` custom-page-css flex flex-col w-full gap-4`}
                  >

                    {fields.map(({ key, name, ...restField }, index) => (
                      <div
                        key={key}
                        className="custom-page-css gap-4 items-end"
                      >
                        {/* Brandname */}
                        <Form.Item
                          {...restField}
                          name={[name, "brandName"]}
                          label="Brandname"
                          rules={[{ required: true, message: "Chọn brandname" }]}
                        >
                          <Select
                            placeholder="Brandname"
                            className='custom-page-css border rounded overflow-hidden'
                            options={getOptions(
                              form.getFieldValue(["brandNameIds", name, "brandName"])
                            )}
                            onChange={(value) => handleSelectBrand(value, name)}
                          />
                        </Form.Item>
                        {/* Thương hiệu hãng xe */}

                        {/* Delete */}
                        {/* <Button
                            danger
                            disabled={fields.length === 1}
                            icon={<DeleteOutlined />}
                            onClick={() => remove(name)}
                          /> */}

                      </div>
                    ))}

                    {/* Add button */}
                    {/* <Button
                        type="dashed"
                        icon={<PlusOutlined />}
                        onClick={() =>
                          add({
                            categoryCarIds: undefined,
                            brandName: undefined
                          })
                        }
                        className="w-fit"
                      >
                        Thêm brandname
                      </Button> */}

                  </div>
                )}
              </Form.List>
              <Form.Item
                className='custom-page-css w-full'
                name="templateId"
                label="ID mẫu thông báo"
                rules={[{ required: true, message: 'ID mẫu không được để trống!' }]}
              >
                <Select
                  placeholder="Nhập ID mẫu đã được duyệt bởi Zalo ZNS"
                  className='custom-page-css border rounded overflow-hidden'
                  options={sLTemplateZaloFromConek}
                  // onChange={(data)=> console.log(data)}
                  onSelect={(value, option) => {
                    // setContentTemplateZaloFromConek(option.content)
                    form.setFieldValue(
                      'content',
                      option.content ?? ''
                    );
                  }}
                />
              </Form.Item>
            </div>



            <Form.Item
              name="typeZNSId"
              rules={[{ required: true, message: 'Vui lòng chọn loại ZNS!' }]}
              label="Loại ZNS"
            >
              <Select
                placeholder="chọn loại ZNS"
                className='custom-page-css border rounded overflow-hidden'
                options={sLTypeZNS.map((item) => ({
                  value: item.id,
                  label: item.title
                }))}
              />
            </Form.Item>

            <div className="d-flex justify-between align-center pb-4">
              <p className="text-base fw-700 font-bold text-344054 pb-4">Nội dung</p>
              {/* <div className="w-250-px">
                <Form.Item
                  name="variables"
                  className="m-none-form-item text-explan"
                >
                  <Select
                    showSearch
                    onSearch={(value) => {
                      setSearchText(value);
                      setSearchTemplate(value);
                    }}
                    value={selectValue}
                    open={openMap}
                    onDropdownVisibleChange={(open) => {
                      setOpenMap(open);
                      if (!open) {
                        setSearchText('');
                        setSearchTemplate('')
                      }
                    }}
                    onChange={(value) => {
                      setSelectValue(value);
                    }}
                    placeholder="Tham số"
                    // style={{ width: 320 }}
                    optionFilterProp="label"
                    options={selectableOptions}
                    filterOption={false}

                    dropdownRender={() => (
                      <div
                        style={{
                          maxHeight: 350,
                          overflowY: "auto",
                        }}
                      >
                        {options.filter((item) => {
                          if (!searchText) return true;
                          const keyword = searchText.toLowerCase();
                          if (item.isGroup) {
                            // Giữ group nếu có child khớp
                            return options.some(
                              (o) => !o.isGroup && o.parentKey === item.key && o.label.toLowerCase().includes(keyword)
                            );
                          }
                          return item.label.toLowerCase().includes(keyword);
                        }).map((item) => {
                          if (item.isGroup) {


                            return (
                              <div
                                key={item.key}
                                onClick={() => toggleGroup(item.key)}
                                style={{
                                  padding: "8px 12px",
                                  fontWeight: 600,
                                  background: "#fafafa",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                <CaretDownOutlined
                                  rotate={expandMap.includes(item.key) ? 0 : -90}
                                />
                                {item.title}
                              </div>
                            );
                          }

                          const groupKey = item.parentKey;
                          if (groupKey && !expandMap.includes(groupKey)) {
                            return null;
                          }

                          return (
                            <div
                              key={item.key}
                              onMouseDown={(e) => {
                                e.preventDefault();
                              }}
                              // onClick={() => {
                              //     console.log(i, item)
                              //     setValue(item.value); // chọn value
                              //     handleChangeField(i, item);
                              //     setOpen(false);       // đóng dropdown
                              // }}
                              className="custom-page-css flex justify-between items-center gap-2 items-option"
                              onClick={() => {
                                // handleChangeField(i, item);
                                setSelectValue(item.value);

                                form.setFieldValue("variables", item.value);

                                setOpenMap(false);
                              }}
                              style={{
                                padding: "8px 32px",
                                cursor: "pointer",

                              }}
                            >
                              {item.label} {`{${item?.fieldCode}}`}
                              <CopyOutlined
                                style={{
                                  color: '#096DD9'
                                }}
                                onClick={async (e) => {
                                  e.stopPropagation();

                                  const textToCopy = `{{${item.fieldCode}}}`;

                                  await navigator.clipboard.writeText(textToCopy);

                                  message.success("Đã copy");
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  />
                </Form.Item>
              </div> */}
            </div>
            <Form.Item
              name="content"
              rules={[{ required: true, message: 'Nội dung không được để trống!' }]}
              className='t-mb-16'
            >
              <Mentions
                rows={10}
                options={sLParameters}
                disabled
              // defaultValue={contentTemplateZaloFromConek}
              />
            </Form.Item>
            <div className="d-flex align-center justify-end gap-6-px">
              <p className="d-flex  text-98A2B3 text-xs font-regular">
                Số lượng ký tự (
                <p className="text-1890FF text-xs font-regular">{content?.length}
                </p>
                )
              </p>
            </div>
          </Form>
        </div>

        <div className="custom-page-css flex flex-1 right-new">
          <div className="t-title-16-bold t-mb-12">Xem trước mẫu gửi đi</div>
          <div className="inner-block">
            <div className="inner-mod">
              <div className="img-block">
                <img src="/avatar-pr.svg" alt="" />
                <div className="title">THACO AUTO</div>
              </div>
              <div className="t-px-24">
                <div className="content-block">
                  {convertStringToHTML(content)}
                </div>
                {/* <div className="time">3:39PM</div> */}
              </div>
            </div>
          </div>

          <div className="btn-reset">
            <div className="btn">
              <div className="icon-svg"><ReloadOutlined /></div>
              <div className="text">Tải lại mẫu xem trước</div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default NotificationZNSCreate
